import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useFormikContext } from 'formik';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type PermissionValues } from '../../../utilities/hasPermissions';
import { type WebpageFormikValue } from './shared';
import { getNewBlock } from './WebpageBlock/shared';
import WebpageDetailsBlock from './WebpageDetailsBlock';
import WebpageMainDetailsForm from './WebpageMainDetailsForm';

const StyledButton = styled(Button)`
    margin-top: 10px;
`;
type WebpageFormProps = {
    updated?: string;
    moduleDisplayName?: string;
    hasLiveChat?: boolean;
    offset?: string;
    permissions: Partial<Pick<PermissionValues, 'hasCreatePermission' | 'hasUpdatePermission'>>;
};

const WebpageForm = ({ updated, moduleDisplayName, hasLiveChat, offset, permissions }: WebpageFormProps) => {
    const { t } = useTranslation('webpageDetails');
    const { setFieldValue, values } = useFormikContext<WebpageFormikValue>();
    const { hasCreatePermission, hasUpdatePermission } = permissions;
    const hasPermissions = hasCreatePermission || hasUpdatePermission;
    const addBlock = useCallback(() => {
        setFieldValue('webPageBlock', [...values.webPageBlock, getNewBlock('Column')]);
    }, [setFieldValue, values.webPageBlock]);

    return (
        <>
            <WebpageMainDetailsForm
                disabled={!hasPermissions}
                hasLiveChat={hasLiveChat}
                moduleDisplayName={moduleDisplayName}
                offset={offset}
                updated={updated}
            />
            <WebpageDetailsBlock disabled={!hasPermissions} name="webPageBlock" />
            {hasPermissions && (
                <StyledButton icon={<PlusOutlined />} onClick={addBlock}>
                    {t('webpageDetails:actions.addBlock')}
                </StyledButton>
            )}
        </>
    );
};

export default WebpageForm;
